import { Button, Loading } from "@nextui-org/react";
import * as React from "react";
import ReactToPrint from "react-to-print";
import Receipt from "./Receipt";

export default class Print extends React.PureComponent {
  componentRef = null;
  timer = null;
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      text: "old boring text"
    };
  }

  handleAfterPrint = () => {
    console.log("`onAfterPrint` called"); // tslint:disable-line no-console
    this.setState({ text: "Loaded", isLoading: false });

  };

  handleBeforePrint = () => {
    console.log("`onBeforePrint` called"); // tslint:disable-line no-console
    this.setState({ text: "Loaded", isLoading: false });

  };

  handleOnBeforeGetContent = () => {
    console.log("`onBeforeGetContent` called"); // tslint:disable-line no-console
    this.setState({ text: "Loading new text...", isLoading: true });

  };

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  reactToPrintContent = () => {
    console.log("ref",this.componentRef);
    return this.componentRef;
  };

  reactToPrintTrigger = () => {
    // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
    // to the root node of the returned component as it will be overwritten.

    // Bad: the `onClick` here will be overwritten by `react-to-print`
    // return <button onClick={() => alert('This will not work')}>Print this out!</button>;

    // Good
    return <Button auto flat color='success' className='mr-auto'>
        چاپ رسید
    </Button>;
  };

  render() {
    return (
      <div>
      <Receipt data={this.props} ref={this.setComponentRef} />

        <ReactToPrint
          content={this.reactToPrintContent}
          documentTitle="رسید ثبت نام"
          onAfterPrint={this.handleAfterPrint}
          onBeforeGetContent={this.handleOnBeforeGetContent}
          onBeforePrint={this.handleBeforePrint}
          removeAfterPrint
          trigger={this.reactToPrintTrigger}
        />
        {this.state.isLoading && (
          <Loading />
        )}
      </div>
    );
  }
}
